module.exports = __webpack_public_path__ + "static/media/register.31418c9f.png";